/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Result type for revoking all of a client's remote_sessions.
 */
export type RevokeAllRemoteSessionsResult = {
  /**
   * Number of remote_sessions revoked.
   */
  revokedCount: number;
};

/** @internal */
export const RevokeAllRemoteSessionsResult$inboundSchema: z.ZodMiniType<
  RevokeAllRemoteSessionsResult,
  unknown
> = z.pipe(
  z.object({
    revoked_count: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "revoked_count": "revokedCount",
    });
  }),
);

export function revokeAllRemoteSessionsResultFromJSON(
  jsonString: string,
): SafeParseResult<RevokeAllRemoteSessionsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RevokeAllRemoteSessionsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RevokeAllRemoteSessionsResult' from JSON`,
  );
}
